import {Box, Button, CircularProgress, Dialog, DialogContent, DialogTitle, IconButton} from "@mui/material";
import {VisuallyHiddenInput} from "../../components/styled";
import React, {useState} from "react";
import {useImageUpload} from "./useImageUpload";
import Close from "@mui/icons-material/Close";
import CloudUploadOutlined from "@mui/icons-material/CloudUploadOutlined";
import GridView from "@mui/icons-material/GridView";
import ImageBrowser from "./ImageBrowser";
import ArrowBack from "@mui/icons-material/ArrowBack";

interface ImageUploadDialogProps {
    bucket: string
    onUpload: (url: string) => void
    uploading: boolean
    onClose: () => void
}

export default ({bucket, onUpload, uploading, onClose}: ImageUploadDialogProps) => {

    const {error, uploading: isUploading, uploadImage} = useImageUpload(bucket, onUpload)
    const [select, setSelect] = useState(false)
    return <Dialog open={uploading} maxWidth={"lg"}>
        <DialogTitle sx={{display: "flex", justifyContent: "space-between"}}>
            {select && <IconButton onClick={() => {setSelect(false)}}><ArrowBack/></IconButton>}
            Uploading image
            <IconButton onClick={() => {onClose(); setSelect(false)} }><Close/></IconButton>
        </DialogTitle>
        {!select && <DialogContent sx={{display:"flex", gap: 1}}>
            {error && <Box sx={{color: "error.main"}}>
                {error.message}
            </Box>}
            <Button
                component="label"
                role={undefined}
                variant="contained"
                tabIndex={-1}
                disabled={isUploading}
                startIcon={<CloudUploadOutlined/>}
            >
                {isUploading && <CircularProgress/>} Upload image
                <VisuallyHiddenInput
                    type="file"
                    onChange={(event) => {
                        if (event.target.files) {
                            uploadImage(event.target.files[0])
                        }
                    }}
                />
            </Button>

            <Button
                component="label"
                role={undefined}
                variant="contained"
                tabIndex={-1}
                disabled={isUploading}
                onClick={() => {
                    setSelect(true)
                }}
                startIcon={<GridView/>}
            >
                Select image
            </Button>
        </DialogContent>}

        {select && <DialogContent>
            <ImageBrowser bucket={bucket} onSelectImage={(url) => {
                onUpload(url)
            }}/>
        </DialogContent>}
    </Dialog>
}
